/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useItemVariant} from '.'
import {usePromotions} from '@salesforce/commerce-sdk-react'

/**
 * In the context of a cart product item variant, this component renders a styled
 * list of the selected variation values as well as any promos (w/ info popover).
 */
const ItemPromotions = ({quantity, fontSize = 'sm', ...props}) => {
    const variant = useItemVariant()

    const promotionIds = variant?.priceAdjustments?.map((adj) => adj.promotionId) ?? []
    // Fetch all the promotions given by price adjustments. We display this info in
    // the promotion info popover when applicable.
    const {data: promotions} = usePromotions(
        {
            parameters: {
                ids: promotionIds ? promotionIds.join(',') : ''
            }
        },
        {
            enabled: promotionIds != null && promotionIds.length > 0
        }
    )
    const promos = promotions?.data || []
    const showPromoMessage = variant?.priceAdjustments?.length > 0 && promos
    if (showPromoMessage) {
        return (
            <Stack spacing={1.5} flex={1} {...props}>
                <Flex alignItems="center">
                    <Text lineHeight="18px" fontSize="14px">
                        {promos?.map((promo) => (
                            <Text key={promo?.id} fontSize="14px" lineHeight="18px">
                                {promo?.calloutMsg}
                            </Text>
                        ))}
                    </Text>
                </Flex>
            </Stack>
        )
    }
}

ItemPromotions.propTypes = {
    quantity: PropTypes.object,
    fontSize: PropTypes.string
}

export default ItemPromotions
